import React from 'react'

export default function ButtonMenu() {
  return (
    <button>
      <i class='bx bx-menu' ></i>
    </button>
  )
}
